import gql from 'graphql-tag';

export const _GET_RECIPIENTS = gql`
	query gqlRecipients_getRecipients(
		$partRef: uuid!
		$limit: Int = 10
		$offset: Int = 0
		$searchTerm: String
		$orderBy: [risolto_recipient_order_by!]
	) {
		total: risolto_recipient_aggregate(
			where: {
				_or: [
					{ name: { _ilike: $searchTerm } }, 
					{ account_id: { _ilike: $searchTerm } }
					{ channel_endpoints:
						{
							_and:[
								{ channel:{ _eq:"EMAIL" } }
								{ endpoint:{ _ilike:$searchTerm } }
							]
						}
					}
				]
				participant: { _eq: $partRef }
			}
			order_by: $orderBy
		) {
			aggregate {
				count
			}
		}
		recipients: risolto_recipient(
			limit: $limit
			offset: $offset
			where: {
				_or: [
					{ name: { _ilike: $searchTerm } }, 
					{ account_id: { _ilike: $searchTerm } }
					{ channel_endpoints:
						{
							_and:[
								{ channel:{ _eq:"EMAIL" } }
								{ endpoint:{ _ilike:$searchTerm } }
							]
						} 
					}
				]
				participant: { _eq: $partRef }
			}
			order_by: $orderBy
		) {
			balance_amount
			due_balance_amount
			name
			reference
			type
			participant
			legal_id_type
			legal_id
			legal_entity
			legal_entity_by_reference {
				reference
				registration_name
			}
			account_id
			contacts {
				reference
				first_name
				last_name
			}
			invoice_documents_aggregate {
				aggregate {
					sum {
						open_amount
						total_amount
					}
				}
			}
		}
	}
`;

export const _GET_RECIPIENT = gql`
	query gqlRecipients_getRecipient($participant: uuid!, $recipient: uuid!) {
		risolto_recipient(where: { reference: { _eq: $recipient }, participant: { _eq: $participant } }) {
			in_collection
			last_dunning_run_at
			name
			account_id
			participant
			participant_by_reference {
				reference
			}
			legal_entity
			legal_entity_by_reference {
				reference
				registration_name
				company_id
				company_id_type
			}
			address
			language_code
			email_main_contact: contacts(
				where: { identifier: { _eq: "main" }, dunning: { _eq: true }, invoicing: { _eq: true } }
			) {
				reference
				channel_endpoints(where: { channel: { _eq: "EMAIL" } }) {
					endpoint
				}
			}
			postal_main_contact: contacts(
				where: { identifier: { _eq: "main" }, dunning: { _eq: true }, invoicing: { _eq: true } }
			) {
				reference
				channel_endpoints(where: { channel: { _eq: "MAIL" } }) {
					endpoint_details
				}
			}
			phone_main_contact: contacts(
				where: { identifier: { _eq: "main" }, dunning: { _eq: true }, invoicing: { _eq: true } }
			) {
				reference
				channel_endpoints(where: { channel: { _eq: "PHONE" } }) {
					endpoint
				}
			}
			sms_main_contact: contacts(
				where: { identifier: { _eq: "main" }, dunning: { _eq: true }, invoicing: { _eq: true } }
			) {
				reference
				channel_endpoints(where: { channel: { _eq: "SMS" } }) {
					endpoint
				}
			}
			contacts {
				reference
				first_name
				last_name
			}
			main_endpoints:channel_endpoints(
				where:{
					contact:{_is_null:true}
					channel: { _neq: "SMS" }
				},
				order_by: {  deactivated_at:asc_nulls_first, channel: asc }
				){
					channel
					endpoint
					endpoint_details
					deactivated_at
			}
			channel_endpoints {
				channel
				contact_by_reference {
					first_name
					last_name
				}
			}
			preferred_invoicing_channel
			balance_amount
			due_balance_amount
			reference
			custom_fields
			legal_id_type
			legal_id
			type
			dunning_is_dirty
			tags {
				tag
				tag_name
				can_remove
			}
			currentActions: actions(
				where: { status: { _eq: OPEN } }
				limit: 2
				order_by: { start_time: desc_nulls_last }
			) {
				reference
				start_time
			}
			totalCurrentActions: actions_aggregate(where: { status: { _eq: OPEN } }) {
				aggregate {
					count
				}
			}
			invoice_documents_aggregate {
				aggregate {
					sum {
						open_amount
						total_amount
					}
				}
			}
			total_open: invoice_documents_aggregate(where: { status: { _eq: OPEN } }) {
				aggregate {
					sum {
						total_amount
						open_amount
					}
				}
			}
			total_paid: invoice_documents_aggregate(where: { status: { _eq: PAID } }) {
				aggregate {
					sum {
						total_amount
						open_amount
					}
				}
			}
			total_rfs: invoice_documents_aggregate(where: { status: { _eq: READY_FOR_SUBMISSION } }) {
				aggregate {
					sum {
						total_amount
						open_amount
					}
				}
			}
		}
	}
`;
